<template>
    <div class="dropdown-menu-wrap" v-if="open" ref="menu" v-click-outside="close">
        <span class="close-icon-wrapper">
            <i class="close" @click="close()"></i>
        </span>
        <div class="dropdown-menu">
            <ul>
                <li v-if="isChart">
                    <span @click="charts">7 days range chart</span>
                </li> 
                <li v-if="targetUrl">
                    <a v-bind:href="targetUrl" target="_blank">Target Link</a>
                </li> 
                <li v-if="finalUrl">
                    <a v-bind:href="finalUrl" target="_blank">Landing Page</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .dropdown-menu-wrap {
        position: fixed;
        background-color: #fff;
        padding: 5px;
        border: 1px solid #d7d7d7;
        border-radius: 3px;
        -webkit-box-shadow: 1px 3px 7px 1px #cbcccd;
        box-shadow: 1px 3px 7px 1px #cbcccd;
        width: max-content;
        z-index:60;
    }

    .close-icon-wrapper {

        display: block;
        text-align: right;

        i.close {
            display: inline-block;
            width: 1em;
            height: 1em;
            color: #fff;
            background-image: url("/static/img/icon-close-black.svg");
            background-repeat: no-repeat;
            background-position: 50%;
            cursor: pointer;
        }
    }

    .dropdown-menu {
        padding: 0 10px 10px;

        ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                margin-top: 5px;
                margin-bottom: 5px;

                a, span {
                    cursor: pointer;
                    color: #666;
                    text-decoration: none;
                    line-height: 24px;

                    &:hover {
                        color: rgb(0, 81, 255);
                    }
                }
            }
        }
    }
</style>
<script>
    
    export default {
        name: "adgroup-report-adgroup-dropdown-menu",

        mixins: [
        ],

        props: {
            open: {
                type: Boolean,
                required: false,
                default: () => true
            },

            options: {
                type: Object,
                required: false,
                default: () => {}
            }
        },

        data() {
            return {
            }
        },   
        
        updated() {           
            if(  this.$refs['menu'] ) {
                this.$refs['menu'].style.top  = this.options.top + 'px';
                this.$refs['menu'].style.left = this.options.left + 'px';
            }
        },

        computed: {

            isChart: function() {                
                let neededFields = ['siteId', 'sourceId', 'campaignName', 'adGroupName'];
                let keys = _.keys(this.options.node);
                return _.difference(neededFields, keys).length == 0;
            },

            targetUrl: function(){
                return _.get(this.options, 'node.targetUrl');
            },

            finalUrl: function(){
                return _.get(this.options, 'node.finalUrl');
            },
        },

        methods: {
            close: function(){
                this.$emit('close');
            },

            charts: function() {
                this.$emit('charts', this.options.node);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/reports/adgroupReport2/AdGroupDropdownMenu.vue